<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { setLocale, type Locale } from '@/i18n'

const { locale } = useI18n()

function pick(l: Locale) {
  setLocale(l)
}
</script>

<template>
  <div class="lang-toggle" id="langToggle" :data-active="locale">
    <span class="lang-toggle-pill" aria-hidden="true"></span>
    <button
      type="button"
      :class="{ active: locale === 'de' }"
      data-lang="de"
      @click="pick('de')"
    >
      DE
    </button>
    <button
      type="button"
      :class="{ active: locale === 'en' }"
      data-lang="en"
      @click="pick('en')"
    >
      EN
    </button>
  </div>
</template>

<style scoped>
.lang-toggle {
  position: relative;
}

.lang-toggle button {
  position: relative;
  z-index: 1;
  flex: 1 1 0;
  text-align: center;
  /* Override legacy active styles so the sliding pill is the only green element */
  background: transparent !important;
  box-shadow: none !important;
  transition: color .25s ease;
}

.lang-toggle button.active {
  color: var(--white);
}

.lang-toggle-pill {
  position: absolute;
  top: 3px;
  bottom: 3px;
  left: 3px;
  width: calc(50% - 3px);
  background: var(--primary-dark);
  border-radius: 100px;
  box-shadow: 0 2px 8px rgba(19, 134, 90, 0.25);
  transform: translateX(0);
  transition: transform .35s cubic-bezier(.4, 0, .2, 1);
  z-index: 0;
  pointer-events: none;
}

.lang-toggle[data-active='en'] .lang-toggle-pill {
  transform: translateX(100%);
}

@media (prefers-reduced-motion: reduce) {
  .lang-toggle-pill {
    transition: none;
  }
}
</style>
